/** Holds the id of the unsent new-chat draft, so it survives a reload. */
export const ACTIVE_NEW_CHAT_DRAFT_KEY = 'aline-chat-active-draft';

const drafts = new Map<string, string>();

export function getChatDraftKey(threadId: string | null, newDraftId?: string) {
  if (threadId) return `aline-chat-draft:thread:${threadId}`;
  if (newDraftId) return `aline-chat-draft:new:${newDraftId}`;
  return 'aline-chat-draft';
}

export function readChatDraft(key: string): string {
  const cached = drafts.get(key);
  if (cached !== undefined) return cached;
  try {
    const stored = sessionStorage.getItem(key);
    const value: unknown = stored === null ? null : JSON.parse(stored);
    if (typeof value === 'string') return value;
  } catch {
    // Keep drafts in memory when browser storage is unavailable.
  }
  return '';
}

export function writeChatDraft(key: string, text: string) {
  drafts.set(key, text);
  try {
    sessionStorage.setItem(key, JSON.stringify(text));
  } catch {
    // The in-memory draft still survives navigation in this session.
  }
}
